export const TEACHER_CANDIDATE_LIST = '/teacher-candidate-list'
export const TEACHER_CANDIDATE_EVALUATION = '/teacher-candidate-evaluation'
export const TEACHER_CANDIDATE_RESULT = `${TEACHER_CANDIDATE_LIST}/results/:id(\\d+)?`

export const DEMO_LESSON_COURSE = '/demo-lesson-course'
export const DEMO_LESSON_MODULE = '/demo-lesson-module'
